<template>
    <div class="container-fluid">
        <div v-if="$can('orders update')" class="row justify-content-center">
            <div class="default-page-width">
                <div class="card card-default">
                    <div class="card-header">{{$t('orders.'+mode+'.title')}}</div>
                    <div class="card-body">
                        <form-order
                            :mode="mode"
                            :orderid="orderid"
                            :context="context"
                            :formdisabled="formdisabled"
                        ></form-order>
                    </div>
                </div>
            </div>
        </div>
        <h1 v-if="!$can('orders update')">{{$t('access-denied')}}</h1>
    </div>
</template>

<script>
export default {
    name: "order-edit",
    props: {
        user: [String, Number],
        formdisabled: {
            type: Boolean,
            default: false
        },
        orderid: [Number, Boolean],
        mode: {
            type: String,
            default: 'create'
        },
        context:[String]
    },
}
</script>

<style scoped>

</style>
